import { LineGraph } from "./LineGraph";
import "./Tab.scss";
import techData from "../../data/technologies.json";
import OpSelect from "../OpSelect/OpSelect";
import { useEffect, useMemo, useState } from "react";
import { Choropleth } from "./Choropleth";

export function Tab({
	category,
	numberGraph,
	valueGraph,
	numberTemplate,
	valueTemplate,
	choropleth,
	title,
	prefix,
	slug,
	noDataMessage,
	setSelectedComparisonTechnology,
	selectedComparisonTechnology,
}) {
	const [comparisonData, setComparisonData] = useState(null);
	const techListWithoutCurrent = useMemo(
		() => techData.filter((o) => o.slug !== slug),
		[slug]
	);
	useEffect(() => {
		(async () => {
			if (selectedComparisonTechnology && selectedComparisonTechnology.slug) {
				const data = await import(
					`../../data/techs/${selectedComparisonTechnology.slug}.json`
				);
				setComparisonData(data);
			} else {
				setComparisonData(null);
			}
		})();
	}, [selectedComparisonTechnology]);

	return (
		<div className={"technology-profile-tab"}>
			{!(numberGraph && numberGraph.data.length) &&
			!(valueGraph && valueGraph.data.length) &&
			!(choropleth && choropleth.data.length) ? (
				<div className={"technology-profile-tab__no-data"}>{noDataMessage}</div>
			) : null}
			{(numberGraph && numberGraph.data.length) ||
			(valueGraph && valueGraph.data.length) ? (
				<OpSelect
					options={techListWithoutCurrent}
					getLabel={(o) => o.title}
					getValue={(o) => o.slug}
					selected={selectedComparisonTechnology}
					handleChange={setSelectedComparisonTechnology}
					placeholder={"Add Tech Comparison"}
					allowEmpty={true}
				/>
			) : null}
			{numberGraph && numberGraph.data.length > 0 && (
				<LineGraph
					title={title}
					type={"count"}
					graph={numberGraph}
					tooltipTemplate={numberTemplate}
					comparisonData={comparisonData}
					comparisonGraph={
						comparisonData
							? comparisonData.data[category.toLowerCase()].countGraph
							: null
					}
				/>
			)}
			{valueGraph && valueGraph.data.length > 0 && (
				<LineGraph
					title={title}
					type={"value"}
					graph={valueGraph}
					tooltipTemplate={valueTemplate}
					comparisonData={comparisonData}
					prefix={prefix}
					comparisonGraph={
						comparisonData
							? comparisonData.data[category.toLowerCase()].valueGraph
							: null
					}
				/>
			)}
			{choropleth && choropleth.data.length > 0 && (
				<Choropleth data={choropleth} />
			)}
		</div>
	);
}
